import { supabase } from '@/lib/supabase';

export const deleteChart = async ({
  chartId,
}: {
  chartId: number;
}): Promise<void> => {
  const { error } = await supabase
    .from('chart_configs')
    .delete()
    .eq('id', chartId);

  if (error) {
    throw error;
  }

  return;
};
